import { mark } from '@hotjar/performance';
import { MARKS } from '@hotjar/webapp/performance';
import { RecordingPlaybackTracker } from '@hotjar/webapp/recordings/recording-playback-tracker';
import { Recording } from '@hotjar/webapp/features/Playbacks/types';
import { preloadRecordingByIndex } from './preloadRecordingByIndex';
import { increment as statefulIncrementTracker } from '@hotjar/webapp/recordings/useStatefulPlaybackTracker';
import { Store } from '../../../store/player/types';
import { resetPlayer } from './resetPlayer';
import { getRecordingPath } from '../../../../src/utils/getRecordingPath';

/**
 * Attempt to go to the recording by index.
 */
export const goToRecordingByIndex = async (store: Store, index: number): Promise<void> => {
  try {
    mark(MARKS.PLAYBACKS_NEXT_RECORDING_FETCH_START);
    const recording = await preloadRecordingByIndex(store, index);
    if (!recording) return;

    goToRecording(store, recording);
  } catch {
    const { setIsRecordingListOutOfSync } = store.getState();
    setIsRecordingListOutOfSync(true);
  }
};

export const goToRecording = (store: Store, recording: Recording): void => {
  const { setIsRecordingListOutOfSync, siteId, user } = store.getState();
  RecordingPlaybackTracker.incrementWatched();

  if (siteId && user?.user_id) {
    statefulIncrementTracker(siteId, Number(user.user_id));
  }

  setIsRecordingListOutOfSync(false);
  const recordingUrl = getRecordingPath(recording, 'recordings-player');

  try {
    window.history.pushState('', '', recordingUrl);
    resetPlayer(store);
  } catch {
    window.location.href = recordingUrl;
  }
};
